import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, withRouter } from "react-router-dom";
import { OrderCard } from "./OrderCard";
import { Col, Row, Spinner, Form } from "react-bootstrap";
import "./Order.scss";
import { DeleteOrderModal } from "../Modals/DeleteOrderModal";
import { RatingOrderModal } from "../Modals/RatingOrderModal";
import { GrabOrderModal } from "../Modals/GrabOrderModal";
import { ResendOrderModal } from "../Modals/ResendOrderModal";
import { CancelOrderModal } from "../Modals/CancelOrderModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOrder,
  grabOrder,
  resendOrder,
  rateOrder,
  cancelOrder,
  setCurrentData,
  orderList,
} from "../../../redux/actions/dbactions/orderActions";
import { getSession } from "../../../redux/actions/authActions";
import OrderDetailsModal from "./OrderDetailsModal";
import EditOrderPrice from "./EditOrderPrice";
import OrderVelocity from "./OrderVelocity";
import OrderInstructions from "./OrderInstructions";
import { Reschedule } from "./Reschedule";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Header } from "../../Header";
import OrdersIcon from "../../../../assets/OrdersIcon";
import { toast } from "react-toastify";

const Order = ({ searchQuery, showDropdown, toggleDropdown }) => {
  const dispatch = useDispatch();
  const { order, isLoading } = useSelector((state) => state.orderlist);
  const { refsdata } = useSelector((state) => state.refstypes);
  const [show, setShow] = useState(false);
  const [editmodal, setEditmodal] = useState(false);
  const [velocitymodal, setVelocitymodal] = useState(false);
  const [instrmodal, setInstrmodal] = useState(false);
  // const [editpricemodal, setEditpricemodal] = useState(false);
  const [deletemodal, setDeletemodal] = useState(false);
  const [ratemodal, setRatingmodal] = useState(false);
  const [grabmodal, setGrabmodal] = useState(false);
  const [resendmodal, setResendmodal] = useState(false);
  const [rescheduleModal, setRescheduleModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [rating, setRating] = useState(0);
  // const [selectedTitle, setSelectedTitle] = useState(null);
  // const [refresh, setRefresh] = useState(false);
  const [orderData, setOrderData] = useState({});
  const [userName, setUserName] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");

  const { role_id } = getSession();
  const statuses = refsdata.usr?.statuses || [];

  const uniqueStatuses = [
    ...new Set(statuses.map((status) => status.s_status_cd)),
  ];

  const [page, setPage] = useState(1);
  const observer = useRef(null);

  const lastOrderRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && order?.usr?.data?.length > 0) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [isLoading, order?.usr?.data?.length]
  );

  useEffect(() => {
    dispatch(orderList(page, startDate, endDate));
  }, [page, startDate, endDate, dispatch]);

  const [previousOrders, setPreviousOrders] = useState([]);

  useEffect(() => {
    if (!order?.usr?.data) return;

    const newFilteredOrders = order.usr.data.filter((o) => {
      const orderDate = parseOrderDate(o.order_dte_tsp);
      const statusMatches = !selectedStatus || o.s_status_cd === selectedStatus;
      const searchMatches = safeLower(o.order_id).includes(
        searchQuery.toLowerCase()
      );

      return (
        statusMatches &&
        searchMatches &&
        (!startDate || orderDate >= startDate) &&
        (!endDate || orderDate <= endDate)
      );
    });

    setPreviousOrders((prev) =>
      page === 1
        ? newFilteredOrders
        : [...prev, ...newFilteredOrders].reduce((acc, order) => {
            if (!acc.some((o) => o.order_id === order.order_id))
              acc.push(order);
            return acc;
          }, [])
    );
  }, [order, selectedStatus, startDate, endDate, searchQuery, page]);

  const filteredOrders = previousOrders;

  const safeLower = (value) => (value ? value.toString().toLowerCase() : "");

  const parseOrderDate = (dateString) => {
    const [day, month, year, time] = dateString.split(/[\s:-]+/);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthIndex = months.indexOf(month);
    return new Date(year, monthIndex, day, ...time.split(":"));
  };

  const handleEditModal = (data) => {
    setEditmodal(true);
    // setRefresh(false);
    setOrderData(data);
    setSelectedId(data.order_id);
    dispatch(setCurrentData(data));
  };
  const handleInstrModal = (data) => {
    setInstrmodal(true);
    // setRefresh(false);
    setOrderData(data);
    setSelectedId(data.order_id);
  };
  const handleVelocityModal = (data) => {
    setVelocitymodal(true);
    // setRefresh(false);
    setOrderData(data);
    setSelectedId(data.order_id);
  };
  // const handleAddPriceModal = (data) => {
  //   // setEditpricemodal(true);
  // setRefresh(false);
  //   setOrderData(data);
  //   setSelectedId(data.order_id);
  //   dispatch(setCurrentData(data));
  // };

  const handleSeeOrder = (data) => {
    setEditmodal(true);
    // setRefresh(false);
    const {
      order_id,
      order_num,
      user_profile_id,
      order_dte_tsp,
      order_tot_amt,
      order_tot_tax,
      order_tot_fees,
      order_svcf_id,
      order_ship_to_id,
      order_ship_instructions,
      order_bill_to_id,
      order_status_id,
    } = data;

    setOrderData({
      order_id,
      order_num,
      user_profile_id,
      order_dte_tsp,
      order_tot_amt,
      order_tot_tax,
      order_tot_fees,
      order_svcf_id,
      order_ship_to_id,
      order_ship_instructions,
      order_bill_to_id,
      order_status_id,
    });
  };
  const handleGrab = () => {
    if (selectedId) {
      dispatch(grabOrder(selectedId));
      // setRefresh(true);
      setGrabmodal(false);
    }
  };
  const handleResend = (sendToCustomer, sendToProvider, sendToPatient) => {
    if (selectedId) {
      dispatch(
        resendOrder(selectedId, sendToCustomer, sendToProvider, sendToPatient)
      );
      // setRefresh(true);
      setResendmodal(false);
    }
  };
  const handleDelete = () => {
    if (selectedId) {
      dispatch(deleteOrder(selectedId));
      // setRefresh(true);
      setDeletemodal(false);
    }
  };
  const handleRating = () => {
    if (selectedId) {
      dispatch(rateOrder(selectedId, rating));
      // setRefresh(true);
      setRatingmodal(false);
    }
  };
  const handleCancel = () => {
    if (selectedId) {
      dispatch(cancelOrder(selectedId));
      // setRefresh(true);
      setShow(false);
    }
  };

  const handleShow = (orderId, orderName) => {
    setShow(true);
    // setRefresh(false);
    setSelectedId(orderId);
    // setSelectedTitle(orderName);
  };

  const handleGrabShow = (orderId, orderName) => {
    setGrabmodal(true);
    // setRefresh(false);
    setSelectedId(orderId);
    // setSelectedTitle(orderName);
  };
  const handleResendShow = (orderId, orderName) => {
    setResendmodal(true);
    // setRefresh(false);
    setSelectedId(orderId);
    // setSelectedTitle(orderName);
  };
  const handleDeleteShow = (orderId, orderName) => {
    setDeletemodal(true);
    // setRefresh(false);
    setSelectedId(orderId);
    // setSelectedTitle(orderName);
  };
  const handleRatingShow = (orderId, orderName, rating) => {
    setRatingmodal(true);
    // setRefresh(false);
    setSelectedId(orderId);
    // setSelectedTitle(orderName);
    setRating(rating);
  };
  const handleRescheduleShow = (
    orderId,
    orderUserName,
    appointmentDate,
    appointmentTime
  ) => {
    if (!appointmentDate) {
      toast.error("Invalid appointment date");
      return;
    }

    try {
      const dateParts = appointmentDate.split("-");
      const day = dateParts[0];
      const month = dateParts[1];
      const year = dateParts[2];
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthIndex = monthNames.indexOf(month);
      if (monthIndex === -1) throw new Error("Invalid month name");

      const formattedDate = `${year}-${String(monthIndex + 1).padStart(
        2,
        "0"
      )}-${String(day).padStart(2, "0")}`;

      setRescheduleModal(true);
      setSelectedId(orderId);
      setUserName(orderUserName);
      setSelectedDate(formattedDate);
      setSelectedTime(appointmentTime);
    } catch (err) {
      toast.error(
        `${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
    }
  };

  return (
    <div>
      <Header pageTitle="Orders" icon={<OrdersIcon />} />
      <div className="ser_title_b px-[0.75rem] sm:px-8 mt-3">
        <h5 className="title">Orders</h5>
        <div className="date-pickers pb-3">
          <Form.Group controlId="filterDropdown">
            <label>Filter</label>
            <Form.Select
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              className="date-picker-input mb-1"
            >
              <option value="">All</option>
              {uniqueStatuses.map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <div className="date-picker-container ">
            <label>Start Date:</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              placeholderText="Start Date"
              className="date-picker-input"
            />
          </div>
          <div className="date-picker-container">
            <label>End Date:</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              placeholderText="End Date"
              className="date-picker-input"
            />
          </div>
        </div>

        {role_id !== 4 && (
          <Link
            to={`/dashboard/`}
            className="sign_btn"
            style={{ fontSize: "12px" }}
          >
            + Add New Order
          </Link>
        )}
      </div>
      {isLoading && filteredOrders.length === 0 ? (
        // Show spinner only if it's the first load and there are no orders yet
        <Col className="text-center">
          <Spinner animation="border" variant="primary" />
        </Col>
      ) : filteredOrders.length > 0 ? (
        <Row className="m-0 sm:px-6">
          {filteredOrders.map((order, index) => {
            if (index === filteredOrders.length - 1) {
              return (
                <Col
                  ref={lastOrderRef}
                  className="mb-3"
                  lg={4}
                  md={6}
                  key={order.order_id}
                >
                  <OrderCard
                    data={order}
                    dispatch={dispatch}
                    handleShow={() =>
                      handleShow(order.order_id, order.order_svcf_id)
                    }
                    handleGrabShow={() =>
                      handleGrabShow(order.order_id, order.order_svcf_id)
                    }
                    handleResendShow={() =>
                      handleResendShow(order.order_id, order.order_svcf_id)
                    }
                    handleRatingShow={() =>
                      handleRatingShow(
                        order.order_id,
                        order.order_svcf_id,
                        order.svc_rating_num
                      )
                    }
                    handleDeleteShow={() =>
                      handleDeleteShow(order.order_id, order.order_svcf_id)
                    }
                    handleInstrModal={() => handleInstrModal(order)}
                    handleVelocityModal={() => handleVelocityModal(order)}
                    handleEditModal={() => handleEditModal(order)}
                    handleSeeOrder={() => handleSeeOrder(order)}
                    handleRescheduleShow={() =>
                      handleRescheduleShow(
                        order.order_id,
                        order.service_user,
                        order.ord_svc_date,
                        order.ord_svc_time
                      )
                    }
                  />
                </Col>
              );
            }
            return (
              <Col className="mb-3" lg={4} md={6} key={order.order_id}>
                <OrderCard
                  data={order}
                  dispatch={dispatch}
                  handleShow={() =>
                    handleShow(order.order_id, order.order_svcf_id)
                  }
                  handleGrabShow={() =>
                    handleGrabShow(order.order_id, order.order_svcf_id)
                  }
                  handleResendShow={() =>
                    handleResendShow(order.order_id, order.order_svcf_id)
                  }
                  handleRatingShow={() =>
                    handleRatingShow(
                      order.order_id,
                      order.order_svcf_id,
                      order.svc_rating_num
                    )
                  }
                  handleDeleteShow={() =>
                    handleDeleteShow(order.order_id, order.order_svcf_id)
                  }
                  handleInstrModal={() => handleInstrModal(order)}
                  handleVelocityModal={() => handleVelocityModal(order)}
                  handleEditModal={() => handleEditModal(order)}
                  handleSeeOrder={() => handleSeeOrder(order)}
                  handleRescheduleShow={() =>
                    handleRescheduleShow(
                      order.order_id,
                      order.service_user,
                      order.ord_svc_date,
                      order.ord_svc_time
                    )
                  }
                />
              </Col>
            );
          })}
          {isLoading && (
            <Col className="text-center">
              <Spinner animation="border" variant="primary" />
            </Col>
          )}
        </Row>
      ) : (
        <Col>
          <p className="text-center">No orders found</p>
        </Col>
      )}
      {showDropdown && (
        <div className="dropdown-menu">
          <ul>
            <li>Order 1</li>
            <li>Order 2</li>
            <li>Order 3</li>
          </ul>
        </div>
      )}
      <CancelOrderModal
        handleCancel={() => {
          handleCancel(selectedId);
          setShow(false);
        }}
        show={show}
        handleClose={() => setShow(false)}
        selectedId={selectedId}
      />
      <DeleteOrderModal
        handleDelete={() => {
          handleDelete(selectedId);
          setDeletemodal(false);
        }}
        show={deletemodal}
        handleClose={() => setDeletemodal(false)}
        selectedId={selectedId}
      />
      <RatingOrderModal
        handleRating={() => {
          handleRating(selectedId, rating);
          setRatingmodal(false);
        }}
        show={ratemodal}
        handleClose={() => setRatingmodal(false)}
        selectedId={selectedId}
        rating={rating}
      />
      <GrabOrderModal
        handleGrab={() => {
          handleGrab(selectedId);
          setGrabmodal(false);
        }}
        show={grabmodal}
        handleClose={() => setGrabmodal(false)}
        selectedId={selectedId}
      />
      <ResendOrderModal
        handleResend={(sendToCustomer, sendToProvider, sendToPatient) => {
          handleResend(sendToCustomer, sendToProvider, sendToPatient);
          setResendmodal(false);
        }}
        show={resendmodal}
        handleClose={() => setResendmodal(false)}
        selectedId={selectedId}
      />
      <OrderDetailsModal
        order={orderData}
        // show={editmodal}
        onHide={() => setEditmodal(false)}
      />
      <EditOrderPrice
        order={orderData}
        show={editmodal}
        selectedId={selectedId}
        onHide={() => setEditmodal(false)}
      />
      <OrderVelocity
        order={orderData}
        show={velocitymodal}
        selectedId={selectedId}
        onHide={() => setVelocitymodal(false)}
      />

      <OrderInstructions
        order={orderData}
        show={instrmodal}
        selectedId={selectedId}
        onHide={() => setInstrmodal(false)}
      />
      <Reschedule
        show={rescheduleModal}
        onHide={() => setRescheduleModal(false)}
        selectedID={selectedId}
        userName={userName}
        selectedDate={selectedDate}
        selectedTime={selectedTime}
        dispatch={dispatch}
      />
    </div>
  );
};

export default withRouter(Order);
